import { getAskAiAdminPath } from '@lumapps/ask-ai/utils';
import { AppId, createPageRoute } from '@lumapps/router';

export const askAiBulkAdminRoute = createPageRoute({
    slug: getAskAiAdminPath('bulk'),
    id: 'ai-search-bulk',
    appId: AppId.backOffice,
});
